import { Icon } from '@iconify/react';
import EvStationIcon from '@mui/icons-material/EvStation';
// material
import { alpha, styled } from '@mui/material/styles';
import { Card, Typography } from '@mui/material';
// utils
import { useState, useEffect } from 'react';
import { fShortenNumber } from '../../../utils/formatNumber';

const axios = require('axios');

// ----------------------------------------------------------------------

const RootStyle = styled(Card)(({ theme }) => ({
  boxShadow: 'none',
  textAlign: 'center',
  padding: theme.spacing(5, 0),
  color: theme.palette.warning.darker,
  backgroundColor: theme.palette.warning.lighter
}));

const IconWrapperStyle = styled('div')(({ theme }) => ({
  margin: 'auto',
  display: 'flex',
  borderRadius: '50%',
  alignItems: 'center',
  width: theme.spacing(8),
  height: theme.spacing(8),
  justifyContent: 'center',
  marginBottom: theme.spacing(3),
  color: theme.palette.warning.dark,
  backgroundImage: `linear-gradient(135deg, ${alpha(theme.palette.warning.dark, 0)} 0%, ${alpha(
    theme.palette.warning.dark,
    0.24
  )} 100%)`
}));

// ----------------------------------------------------------------------

const TOTAL = 1723315;

export default function AppItemOrders() {
  const [gas, setGas] = useState(0);
  useEffect(async () => {
    const res = await axios.get('https://ethgasstation.info/json/ethgasAPI.json');
    const price = res.data.average / 10;
    setGas(price);
  });

  return (
    <RootStyle>
      <IconWrapperStyle>
        <EvStationIcon />
      </IconWrapperStyle>
      <Typography variant="h3">{gas}</Typography>
      <Typography variant="subtitle2" sx={{ opacity: 0.72 }}>
        Gas Price
      </Typography>
    </RootStyle>
  );
}
